import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=82fd6bc6"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardItem.vue?vue&type=style&index=0&id=82fd6bc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports